var render, staticRenderFns
import script from "./ItemFilterList.vue?vue&type=script&lang=ts&"
export * from "./ItemFilterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32927e42",
  null
  
)

export default component.exports